module.exports = __webpack_public_path__ + "static/media/pauseOrder.898659c9.png";